import type { HubRuntimeParameters } from '@robovision/hub'
import type { JobResourcesValues } from './JobResources'


export interface JobRuntimeParametersParams {
  main: JobResourcesValues
}

export class JobRuntimeParameters {
  public readonly main: JobResourcesValues

  public constructor (params: JobRuntimeParametersParams) {
    this.main = params.main
  }

  public serialize (): HubRuntimeParameters {
    return {
      ...(this.main.gpu != null && this.serializeResources(this.main)),
    }
  }

  private serializeResources (value: JobResourcesValues): Partial<HubRuntimeParameters> {
    return {
      resources: {
        limits: {
          gpu: value.gpu,
        },
      },
    }
  }

  public static buildDefault (): JobRuntimeParameters {
    return new JobRuntimeParameters({
      main: {
        gpu: undefined,
      },
    })
  }

  public static fromRuntimeParameters (
    runtimeParameters?: HubRuntimeParameters,
  ): JobRuntimeParameters {
    const mainResources = runtimeParameters?.resources ?? {}

    return new JobRuntimeParameters({
      main: {
        gpu: mainResources.limits?.gpu != null
          ? mainResources.limits?.gpu
          : undefined,
      },
    })
  }
}
